// @ts-nocheck
// Shared with andre-haikal/eufooria; update with its bridge tests.
(function (window, document) {
  'use strict';
  var sent = Object.create(null);

  function cookie(name) {
    var prefix = encodeURIComponent(name) + '=';
    var match = document.cookie.split(';').map(function (part) { return part.trim(); })
      .find(function (part) { return part.indexOf(prefix) === 0; });
    if (!match) return null;
    try { return decodeURIComponent(match.slice(prefix.length)); } catch (_) { return null; }
  }

  function captureAttribution() {
    var fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if (!fbclid || !/^[A-Za-z0-9_-]{1,500}$/.test(fbclid)) return;
    var previous = cookie('_fbc');
    if (previous && previous.slice(previous.lastIndexOf('.') + 1) === fbclid) return;
    var value = 'fb.1.' + Date.now() + '.' + fbclid;
    var domain = /(^|\.)bachatastudio\.ee$/.test(window.location.hostname) ? '; Domain=.bachatastudio.ee' : '';
    document.cookie = '_fbc=' + encodeURIComponent(value) + '; Path=/; Max-Age=7776000; SameSite=Lax' +
      domain + (window.location.protocol === 'https:' ? '; Secure' : '');
  }

  function trackEvents(events) {
    (events || []).forEach(function (event) {
      if (!event || !event.event_id || !event.event_name || typeof window.fbq !== 'function') return;
      var key = 'meta-event:' + event.event_id;
      if (sent[key]) return;
      try { if (window.localStorage.getItem(key)) return; } catch (_) { /* storage may be disabled */ }
      window.fbq('track', event.event_name, event.custom_data || {}, { eventID: event.event_id });
      sent[key] = true;
      try { window.localStorage.setItem(key, '1'); } catch (_) { /* retain the in-memory guard */ }
    });
  }

  window.MetaTracking = {
    trackEvents: trackEvents,
    captureAttribution: captureAttribution,
    context: function () {
      captureAttribution();
      return { fbp: cookie('_fbp'), fbc: cookie('_fbc'),
        event_source_url: window.location.origin + window.location.pathname };
    }
  };
  captureAttribution();
}(window, document));
